#import "../fragments/constant-contact-integration-fragment.graphql"

query GetConstantContactIntegration {
    constantContactIntegration {
        ...ConstantContactIntegration
    }
}
